<template>
    <modal :id="utils.randomId({prefix: 'modal'})"
           :show="true"
           size="xl"
           @close="close()">
        <template #title>
            <div class="w-100 d-flex align-items-center justify-content-between">
                <div>
                    Bulk Print Activities
                    <span>({{ selected_activity_ids.length }})</span>
                </div>
                <div class="btn-group ml-2">
                    <button class="btn btn-light" @click="select()">All</button>
                    <button class="btn btn-light" @click="select(false)">None</button>
                </div>
            </div>
        </template>

        <div v-if="is_busy" class="loading">
            <icon-spinner class="spinner" :spin="true" color="dark" />
        </div>
        <div v-else class="print-sections">

            <div v-for="activity_section in activity_sections" class="stage">

                <div class="h4 d-flex align-items-center justify-content-between">
                    <span>{{ activity_section.stage.name }}</span>
                    <div class="btn-group ml-2">
                        <button class="btn btn-light" @click="select(true, activity_section)">All</button>
                        <button class="btn btn-light" @click="select(false, activity_section)">None</button>
                    </div>
                </div>

                <div v-for="section in activity_section.sections" class="section">

                    <h6>{{ section.name }}</h6>
                    <div class="activities">
                        <template v-for="activity in section.activities">
                            <div v-if="activities[activity.v].type === 'activity'" :key="activity.id" :class="elementWidthClass(activity)" class="item">
                                <div class="form-check">
                                    <input :id="`checkbox-${section.id}-${activity.id}`"
                                           v-model="selected_activity_ids"
                                           :value="activity.v"
                                           class="form-check-input"
                                           type="checkbox">
                                    <label class="form-check-label" :for="`checkbox-${section.id}-${activity.id}`"></label>
                                </div>
                                <activity :activity="activities[activity.v]" :editable="false" :show-preview="false" @click.stop.prevent="toggle(activity)"/>
                            </div>
                        </template>
                    </div>


                </div>

            </div>

        </div>

        <template #footer>

            <template v-if="is_printing">
                <state-button class="btn btn-primary"
                              :disabled="true"
                              state="busy">Preparing...</state-button>
            </template>
            <template v-else>
                <button class="btn btn-primary"
                        @click="print('teacher')"
                        :disabled="is_busy || !selected_activity_ids.length">
                    Print Instructions
                </button>

                <button class="btn btn-primary"
                        @click="print('student')"
                        :disabled="is_busy || !selected_activity_ids.length">
                    Print Student Worksheets
                </button>
            </template>

        </template>
    </modal>
</template>

<script>
import Activity from "@/Components/LearningPath/Activity";
import Modal from "@/Components/Common/Modal";
import utils from '@/mixins/utils';
import API from "@/API";
import IconSpinner from "@/Icons/IconSpinner";
import StateButton from "@/Components/Common/StateButton";
export default {
    name: "PrintActivityModal",
    components: {StateButton, IconSpinner, Activity, Modal},
    mixins: [utils],

    props: ['stage', 'path', 'section'],
    emits: ['close'],

    data(){
        return {
            is_busy: true,
            selected_activity_ids: [],
            selected_type: 'teacher',
            activities: {},
            is_printing: false,
        }
    },

    computed: {

        _$$path(){
            return this.path?.fragments;
        },

        stages(){
            return this._$$path.stages;
        },

        activity_sections(){
            const activity_sections = [];
            for( const i in this._$$path.stages ){
                if( !this._$$path.stages.hasOwnProperty( i ) ) continue;
                const stage_id = this._$$path.stages[ i ];
                const stage = this._$$path[`stage_${stage_id}_config`];
                const sections = this._$$path[`stage_${stage_id}_activity_sections`];

                for( const j in sections ){
                    if( !sections.hasOwnProperty(j) ) continue;
                    const section = sections[ j ];
                    const activities = this._$$path[`stage_${stage_id}_combined_activities_${section.id}`];
                    sections[ j ].activities = Array.isArray( activities ) ? activities : [];
                }

                activity_sections.push({
                    stage_id,
                    stage,
                    sections
                });

            }
            return activity_sections;
        }

    },

    methods: {

        close(){
            this.$emit('close');
        },

        elementWidthClass(element){
            try{ return `aw-${element.data.options.width}` } catch (e) {}
            return 'aw-1';
        },

        select(select = true, activity_section = null){
            if( activity_section ){

                const ids = this.selected_activity_ids;

                for( const i in activity_section.sections ){
                    const section = activity_section.sections[i];
                    for( const j in section.activities ){
                        const activity = section.activities[j];
                        const activity_id = activity.v;

                        if( typeof this.activities[ activity_id ] === 'undefined' || this.activities[ activity_id ].type !== 'activity' ){
                            continue;
                        }

                        const idx = ids.findIndex(id => id === activity_id);
                        if(idx >= 0){
                            if( !select ){
                                ids.splice(idx, 1);
                            }
                        } else {
                            if( select ){
                                ids.push(activity_id);
                            }
                        }
                    }
                }

                this.selected_activity_ids = ids;
                this.$forceUpdate();

            } else {
                for( const i in this.activity_sections ){
                    this.select( select, this.activity_sections[ i ] );
                }
            }
        },

        async print( type ){
            this.is_printing = true;
            const result = await API.activities.print(this.selected_activity_ids, type);
            if( result.handle ){
                const url = this.route('activity.bulk.print.download', {handle: result.handle, ...this.global_url_params});
                window.open(url, '_blank').focus();
                this.close();
            }
            this.is_printing = false;
        },

        async setupActivities(){
            let ids = [];

            let selected = [];
            for( const i in this.activity_sections ){
                if( !this.activity_sections[i]?.sections ) continue;
                for( const j in this.activity_sections[i].sections ){
                    if( !this.activity_sections[i]?.sections[j]?.activities ) continue;
                    const __ids = this.activity_sections[i].sections[j].activities.map(a => a.v);

                    // console.log({
                    //     stage: [this.stage, this.activity_sections[i].stage_id],
                    //     section: [this.section.id, this.activity_sections[i]?.sections[j].id],
                    // });

                    if( this.stage === this.activity_sections[i].stage_id && this.activity_sections[i]?.sections[j].id === this.section.id ){
                        // console.log('CURRENTLY SELECTED', __ids)
                        selected = selected.concat( __ids );
                    }

                    ids = ids.concat( __ids );
                }
            }

            const activities = await API.elements.bulk({ids});
            for( const i in activities){
                this.activities[ activities[i].id ] = activities[i];
            }

            for( const i in selected ){
                if( this.activities[ selected[i] ].type === 'activity' ){
                    this.selected_activity_ids.push( selected[i] );
                }
            }

        },

        toggle(activity){
            const idx = this.selected_activity_ids.indexOf(activity.v);
            if( idx >=0 ) {
                this.selected_activity_ids.splice(idx, 1);
            }else{
                this.selected_activity_ids.push(activity.v);
            }
            this.$forceUpdate();
        }

    },


    async mounted() {

        await this.setupActivities();
        this.is_busy = false;

    }

}
</script>

<style lang="scss" scoped>
.spinner{
    width: auto;
    height: 2rem;
    display: inline-block;
}
.loading{
    padding: 6rem 0;
    text-align: center;
}


.activities{
    display: flex;
    margin-left: -0.3rem;
    margin-right: -0.3rem;
    flex-wrap: wrap;
    align-items: stretch;

    .item{
        display: flex;
        padding: 0 0.3rem;
        margin-bottom: 0.6rem;
        position: relative;
    }
}

.aw-1{
    @include media-breakpoint-up(lg){
        flex: 0 0 20%;
    }
}

.aw-2{
    @include media-breakpoint-up(lg){
        flex: 0 0 40%;
    }
}

.aw-3{
    @include media-breakpoint-up(lg){
        flex: 0 0 60%;
    }
}
.aw-4{
    @include media-breakpoint-up(lg){
        flex: 0 0 80%;
    }
}
.aw-5{

}

.form-check{
    position: absolute;
    z-index: 2;
    left: 10px;
    top: 0;
}

.print-sections{
    overflow: auto;
    height: 75vh;
}

.stage{
    padding: 0 1rem 1rem;
    margin-bottom: 1rem;
    border-bottom: $light-borders solid 1px;

    &:last-child{
        margin-bottom: 0;
        border-bottom: none;
    }
}

</style>
